import { InjectionToken } from '@angular/core';

// A TypeScript interface (Environment) to define the shape of configuration object.
export interface Environment {
  environment: {
    production: boolean;
    apiAuthority: string;
    publicEndpoints: {
      [key: string]: string;
    },
    privateEndpoints: {
      [key: string]: string;
    },
  };
}

// An Angular InjectionToken (ENV_CONFIG) that we will use to inject  config anywhere in the app.
export const ENV_CONFIG = new InjectionToken<Environment>('Environment');
